import { Provider } from '@angular/core';
import {
  COUNTRY_ISO_NUMBER,
  TranslateService,
  TRANSLATION_DICTIONARY_MAPPING,
} from '@i18n';
import { addressTranslationDictionaryMappingFactory } from '../factories/address-translation-dictionary-mapping/address-translation-dictionary-mapping.factory';

export function provideFormsAddressI18n(): Provider {
  return [
    TranslateService,
    {
      provide: TRANSLATION_DICTIONARY_MAPPING,
      useFactory: addressTranslationDictionaryMappingFactory,
      multi: true,
      deps: [COUNTRY_ISO_NUMBER],
    },
  ];
}
